import ConceptsList from 'approot/shared/concepts/concepts-list';
import { LessonTextualConceptsFragment } from './__generated__/LessonTextualConceptsFragment';

const TextualConceptsView = ({
  content,
}: {
  content: LessonTextualConceptsFragment;
}) =>
  content.textualConcepts ? (
    <ConceptsList concepts={content.textualConcepts} />
  ) : null;

export default TextualConceptsView;
